import './styles.scss'

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import I18n from 'lib/i18n'

import Bugsnag from '~/scenes/bugsnag'
import errorIcon from './_assets/error-icon.svg'
import { normalizeString } from 'lib/utils/normalize-string'
import { stripEmojis } from 'lib/utils/message/strip-emojis'

export default class Field extends Component {
  static propTypes = {
    name: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    label: PropTypes.string,
    values: PropTypes.object,
    errors: PropTypes.object,
    size: PropTypes.string,
    onlyField: PropTypes.bool,
    errorHTML: PropTypes.bool,
    children: PropTypes.func,
    dataAttr: PropTypes.string,
    displayError: PropTypes.bool,
    withLogoIcon: PropTypes.bool
  }

  constructor (props) {
    super(props)
    this.state = { hasCrashed: false }
  }

  shouldComponentUpdate (nextProps, nextState) {
    return (
      this.props.name !== nextProps.name ||
      this.props.id !== nextProps.id ||
      this.props.label !== nextProps.label ||
      this.props.values[this.props.name] !== nextProps.values[nextProps.name] ||
      this.props.errors[this.props.name] !== nextProps.errors[nextProps.name] ||
      this.props.size !== nextProps.size ||
      this.props.onlyField !== nextProps.onlyField ||
      this.props.errorHTML !== nextProps.errorHTML ||
      this.props.children !== nextProps.children ||
      this.state.hasCrashed !== nextState.hasCrashed
    )
  }

  setTargetValue = (event, strippedValue) => {
    if (strippedValue !== undefined) {
      const normalizedCurrentValue = stripEmojis(normalizeString(event.target.value))
      this.setValue(normalizedCurrentValue)
    } else {
      this.setValue(event.target.value)
    }
  }

  setValue = currentValue => {
    const { setValue } = this.actions
    const { name, id, values } = this.props
    const normalizedCurrentValue = typeof currentValue === 'string' ? normalizeString(currentValue) : currentValue
    if (typeof id !== 'undefined') {
      const nameValue = values[name]
      if (Array.isArray(nameValue)) {
        let changedValues = nameValue.map((value, index) => (index === id ? normalizedCurrentValue : value))
        if (id >= changedValues.length) {
          changedValues[id] = normalizedCurrentValue
        }
        setValue(name, changedValues)
      } else {
        setValue(name, { ...nameValue, [id]: normalizedCurrentValue })
      }
    } else {
      setValue(name, normalizedCurrentValue)
    }
  }

  componentDidCatch (error) {
    this.setState({ hasCrashed: true })
    Bugsnag.notify(error)
  }

  render () {
    const { hasCrashed } = this.state
    const {
      name,
      id,
      label,
      values,
      errors,
      size = 'short',
      onlyField = false,
      errorHTML,
      children,
      dataAttr,
      displayError = true,
      withLogoIcon
    } = this.props

    if (hasCrashed) {
      return (
        <div className='simple-error bordered-spaced'>
          <span>{I18n.t('errors.field_error')}</span>
        </div>
      )
    }

    const field = children({
      value: typeof id !== 'undefined' ? values[name][id] : values[name],
      setTargetValue: this.setTargetValue,
      setValue: this.setValue
    })

    if (onlyField) {
      return field
    }

    let localError = errors[name]
    let localLabel = label

    if (typeof id !== 'undefined') {
      if (localError) {
        localError = localError[id]
      }
      if (typeof localLabel === 'object' || Array.isArray(localLabel)) {
        localLabel = localLabel[id]
      }
    }

    return (
      <div className={`form-element ${size} ${localError ? 'has-errors' : ''}`} data-attr={dataAttr}>
        {localLabel && <label className='block'>{localLabel}</label>}
        {field}
        {localError && errorHTML && displayError && (
          <div className={withLogoIcon ? 'error-container' : null}>
            {withLogoIcon && <img src={errorIcon} width='16px' height='16px' className='error-icon' alt='error-icon' />}
            <div className='simple-error' dangerouslySetInnerHTML={{ __html: localError }} />
          </div>
        )}
        {localError && !errorHTML && displayError && (
          <div className={withLogoIcon ? 'error-container' : null}>
            {withLogoIcon && <img src={errorIcon} width='16px' height='16px' className='error-icon' alt='error-icon' />}
            <div className='simple-error'>{localError}</div>
          </div>
        )}
      </div>
    )
  }
}
